<template>
  <div>
    <filters :collapsable="false" key="filter-page"></filters>
  </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'

  export default {
    name: 'template',
    props: [],
    data () {
      return {}
    },
    computed: {},
    methods: {},
    components: {Filters}
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// FilterPage.vue?0238d9fa